import axios from "axios";

const getAllByMawbID = id => {
  return axios
    .get(`/mawb/${id}/parcels`)
    .then(response => response)
    .catch(error => {
      throw error
    })
}

const newParcelBriefInfo = obj => {
  return axios.post('/parcel/brief', obj)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const updateStatus = (id, obj) => {
  return axios.patch(`/parcel/${id}/status`, obj)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const searchHAWB = (text) => {
  return axios
  .get(`parcels/search/${text}`)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const getDetailByID = (id) => {
  return axios
  .get(`parcel/${id}/detail`)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const getRejectCode = (status) => {
  return axios
  .get(`rejectCode/${status}`)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

export {
  getAllByMawbID,
  newParcelBriefInfo,
  updateStatus,
  searchHAWB,
  getDetailByID,
  getRejectCode
}
